import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hadapsartomumbaicab() {



const cardData = {
  keyword: " Hadapsar to Mumbai Cabs",

headingDescription:
  "Velocity Cab offers reliable and comfortable Hadapsar to Mumbai cab services, providing hassle-free transportation for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups ensure a smooth journey from Hadapsar to Mumbai. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Hadapsar to Mumbai cab travel.",

topPlaces: [
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is one of Mumbai's most popular seaside promenades, offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing along the waterfront, exploring nearby cafés, and visiting famous celebrity residences. It is an excellent destination for evening walks and photography."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most recognizable monument and a must-visit destination for travelers. Renting an Innova Crysta in Pune makes the journey smooth and comfortable for families and groups planning a Mumbai sightseeing tour. Visitors can admire the historic architecture, enjoy ferry rides to Elephanta Island, and capture memorable photographs overlooking the Arabian Sea."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake offers a peaceful escape from Mumbai's busy streets with scenic waterfront views, boating opportunities, and nearby restaurants. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this picturesque destination for a relaxing outing with family and friends. The surrounding greenery and modern skyline create a perfect setting for photography and leisure."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is one of Mumbai's most famous religious landmarks, situated on a small islet in the Arabian Sea. Visitors hiring an Innova Crysta on rent in Pune can enjoy a convenient drive to this spiritual destination and admire its beautiful Indo-Islamic architecture, peaceful atmosphere, and scenic sea views."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most visited beaches, attracting visitors with its lively atmosphere, street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune allows travelers to enjoy a comfortable road journey before spending quality time by the sea with family and friends."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural marvel and meditation center located near Gorai. Travelers renting an Innova Crysta in Pune can comfortably reach this peaceful attraction to admire its magnificent golden dome, explore the meditation halls, and experience a calm and spiritual environment."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a vibrant shopping destination filled with fashion boutiques, handicraft stalls, cafés, and restaurants. Visitors booking an Innova Crysta on rent in Pune can conveniently explore this bustling market while enjoying shopping, local cuisine, and the colonial charm of South Mumbai."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves are a UNESCO World Heritage Site renowned for their ancient rock-cut temples and magnificent sculptures of Lord Shiva. Travelers choosing an Innova Crysta on rent in Pune can comfortably travel to Mumbai before taking a ferry to Elephanta Island for an unforgettable historical experience."
  },
  {
    title: "Gilbert Hill",
    description: "Gilbert Hill is a rare volcanic rock formation that dates back millions of years and stands as one of Mumbai's hidden attractions. Renting an Innova Crysta in Pune provides a comfortable journey for travelers looking to discover unique geological landmarks and enjoy panoramic city views from the hilltop."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most iconic waterfront destinations. Travelers hiring an Innova Crysta on rent in Pune can relax along the scenic promenade, enjoy breathtaking sunset views, sample local street food, and experience the vibrant charm of Mumbai's coastline."
  }
],



services: [
{
name: "Magarpatta to Mumbai Cab",
description: "Magarpatta to Mumbai cab service offers reliable transportation between Magarpatta City in Pune and Mumbai. Comfortable vehicles with professional drivers ensure safe highway travel through the Mumbai–Pune Expressway. Pickup services are available from homes, offices, and IT parks in Magarpatta. Ideal for business travel, airport transfers, and family trips. Flexible booking options allow convenient cab reservations."
},
{
name: "Hadapsar to Mumbai Taxi Fare",
description: "Hadapsar to Mumbai taxi fare services provide transparent pricing for passengers planning intercity travel from Hadapsar to Mumbai. Travelers can choose sedan, Ertiga, or Innova vehicles based on comfort and budget. Professional drivers ensure safe and punctual journeys via the expressway. Pickup services are available from homes, offices, and residential societies across Hadapsar."
},
{
name: "Hadapsar to Mumbai Airport Taxi Fare",
description: "Hadapsar to Mumbai Airport taxi fare services help travelers estimate travel costs for airport transfers from Hadapsar to Mumbai Airport. Vehicles provide comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure punctual pickup and safe expressway travel. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Hadapsar to Mumbai International Airport Cab",
description: "Hadapsar to Mumbai international airport cab service offers dependable transportation to Chhatrapati Shivaji Maharaj International Airport. Vehicles are well maintained and suitable for long-distance highway travel with luggage capacity for international travelers. Professional drivers ensure safe driving and timely airport arrivals."
},
{
name: "Hadapsar to Mumbai Innova Cab",
description: "Hadapsar to Mumbai Innova cab service provides premium SUV transportation for comfortable highway travel. Innova vehicles offer spacious seating and smooth ride quality suitable for family travel and corporate trips. Professional drivers ensure safe driving and punctual pickup services from Hadapsar and nearby areas."
},
{
name: "Hadapsar to Mumbai Ertiga Cab",
description: "Hadapsar to Mumbai Ertiga cab service offers spacious SUV transportation for travelers traveling between Hadapsar and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Cab Service in Hadapsar",
description: "Cab service in Hadapsar provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe rides across Hadapsar and nearby Pune areas. Flexible booking options allow easy taxi reservations."
},
{
name: "Taxi Service in Hadapsar",
description: "Taxi service in Hadapsar offers dependable transportation for city rides and intercity travel. Vehicles are comfortable and suitable for daily commuting, airport transfers, and long-distance journeys. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Hadapsar to Mumbai One Way Taxi",
description: "Hadapsar to Mumbai one way taxi service provides convenient single-trip transportation between Hadapsar and Mumbai city. Vehicles are suitable for expressway travel with professional drivers ensuring safe journeys. Flexible booking options allow quick one-way cab reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for travelers heading to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys."
},
{
name: "Hadapsar to Mumbai Cab Price",
description: "Hadapsar to Mumbai cab price services help travelers check fare estimates before booking taxis. Prices vary depending on vehicle type such as sedan, Ertiga, or Innova. Transparent pricing ensures passengers know the cost before confirming their ride."
},
{
name: "Hadapsar to Mumbai Airport Cab",
description: "Hadapsar to Mumbai Airport cab service offers dependable airport transportation for passengers traveling from Hadapsar to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Pune to Mumbai Airport Drop Innova",
description: "Pune to Mumbai Airport drop Innova service provides premium SUV transportation for airport transfers. The Innova vehicle offers spacious seating and luggage capacity suitable for travelers heading to Mumbai Airport."
},
{
name: "Hadapsar to Dadar Cabs",
description: "Hadapsar to Dadar cab service offers reliable transportation between Hadapsar in Pune and Dadar in Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Dadar to Mumbai Airport Taxi Fare",
description: "Dadar to Mumbai Airport taxi fare services provide transparent pricing for travelers heading from Dadar to Mumbai Airport. Comfortable vehicles and experienced drivers ensure safe airport transportation."
},
{
name: "Hadapsar to Bandra Cabs",
description: "Hadapsar to Bandra cab service offers dependable transportation between Hadapsar and Bandra in Mumbai. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys."
},
{
name: "Taxi Service in Magarpatta City",
description: "Taxi service in Magarpatta City provides reliable transportation for local rides, airport transfers, and intercity travel. Comfortable vehicles and professional drivers ensure safe journeys across Magarpatta and nearby Pune areas."
},
{
name: "Hadapsar to Mumbai Innova Taxi Fare",
description: "Hadapsar to Mumbai Innova taxi fare services provide pricing details for premium SUV travel between Hadapsar and Mumbai. Innova vehicles offer spacious seating and smooth ride quality suitable for long-distance travel."
},
{
name: "Hadapsar to Navi Mumbai Cab Fare",
description: "Hadapsar to Navi Mumbai cab fare services provide transparent pricing for travelers traveling between Hadapsar and Navi Mumbai. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys."
},
{
name: "Innova Crysta on Rent in Hadapsar",
description: "Innova Crysta on rent in Hadapsar offers premium SUV rental for travelers seeking luxury transportation. The Innova Crysta provides spacious seating and smooth ride quality suitable for long-distance travel and airport transfers."
}
],

tableData: [
["Magarpatta to Mumbai Cab","Hadapsar to Mumbai Taxi Fare"],
["Hadapsar to Mumbai Airport Taxi Fare","Hadapsar to Mumbai International Airport Cab"],
["Hadapsar to Mumbai Innova Cab","Hadapsar to Mumbai Ertiga Cab"],
["Cab Service in Hadapsar","Taxi Service in Hadapsar"],
["Hadapsar to Mumbai One Way Taxi","Pune to Mumbai Airport Cab"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Hadapsar to Mumbai Cab Price","Hadapsar to Mumbai Airport Cab"],
["Pune to Mumbai Airport Drop Innova","Hadapsar to Dadar Cabs"],
["Dadar to Mumbai Airport Taxi Fare","Hadapsar to Bandra Cabs"],
["Taxi Service in Magarpatta City","Hadapsar to Mumbai Innova Taxi Fare"],
["Hadapsar to Navi Mumbai Cab Fare","Innova Crysta on Rent in Hadapsar"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Hadapsar to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Hadapsar to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Hadapsar to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Hadapsar to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Hadapsar",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, IT parks, hotels, and residential societies across Hadapsar and nearby areas like Magarpatta, Amanora, Kharadi, and Mundhwa."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Hadapsar to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Hadapsar to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Hadapsar to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Hadapsar to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Hadapsar to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Hadapsar to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Hadapsar and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Hadapsar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Hadapsar to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and all major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shinde",
    feedback:
      "The Hadapsar to Mumbai journey was very smooth and comfortable. The cab arrived on time, the driver was experienced, and the ride felt safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Traveling from Hadapsar to Mumbai was a pleasant experience. The vehicle was clean, the service was punctual, and the entire trip was hassle-free.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hadapsar to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Hadapsar to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, Bandra, and other Mumbai destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Hadapsar and Magarpatta City to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Hadapsar to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Hadapsar to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Dadar, Bandra, Mumbai airport & more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hadapsartomumbaicab;